import React from 'react'
import FormInputTextDisabled from '../shared/disabled_input';

class RecapCF extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let content;

        content = (
            <form>
                <div className="grid-container container-input-dati-personali">
                    <div className="grid-x grid-padding-x">
                        <div className="cell medium-6">
                            <FormInputTextDisabled label="E-mail" name="emailRecap" value={this.props.email} />
                        </div>
                        <div className="cell medium-6">
                            <FormInputTextDisabled label="Telefono" name="phone" value={this.props.telefono} />
                        </div>
                    </div>
                </div>
                <button type="button" className="underlined modifica_dati" onClick={this.props.handleModificaDati}>
                    Modifica
                </button>
            </form>
        );

        return (
            <div>
                {content}
            </div>
        )
    }
}

export default RecapCF;


// WEBPACK FOOTER //
// ./src/components/dati_personali/recap_cf.js